const languages = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    country_code: 'US',
    lang: 'en',
  }
]

export default languages